module.exports = __webpack_public_path__ + "static/media/459JamesPBrawleyDrNW_2018-06-12_85.6b3f2640.jpg";